// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkOperationErrorFieldsFragment = { __typename?: 'BulkOperationError', id: string, row_index: number, data: any, error: string, completed_at?: number | null };

export type BulkOperationFieldsFragment = { __typename?: 'BulkOperation', id: string, outfitter_id: string, type: Types.BulkOperationType, status: Types.BulkOperationStatus, total_count: number, processed_count: number, successful_count: number, failed_count: number, created_at: number, started_at?: number | null, updated_at: number, completed_at?: number | null, attributes?: { __typename?: 'BulkOperationAttributes', template_id?: string | null, topic_entity_id?: string | null } | null, errors?: Array<{ __typename?: 'BulkOperationError', id: string, row_index: number, data: any, error: string, completed_at?: number | null }> | null };

export type BulkOperationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type BulkOperationQuery = { __typename?: 'Query', bulkOperation: { __typename?: 'BulkOperation', id: string, outfitter_id: string, type: Types.BulkOperationType, status: Types.BulkOperationStatus, total_count: number, processed_count: number, successful_count: number, failed_count: number, created_at: number, started_at?: number | null, updated_at: number, completed_at?: number | null, attributes?: { __typename?: 'BulkOperationAttributes', template_id?: string | null, topic_entity_id?: string | null } | null, errors?: Array<{ __typename?: 'BulkOperationError', id: string, row_index: number, data: any, error: string, completed_at?: number | null }> | null } };

export type BulkOperationsQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  types?: Types.InputMaybe<Array<Types.BulkOperationType> | Types.BulkOperationType>;
  attributes?: Types.InputMaybe<Types.BulkOperationAttributesFilter>;
  paging?: Types.InputMaybe<Types.Paging>;
}>;


export type BulkOperationsQuery = { __typename?: 'Query', bulkOperations: { __typename?: 'BulkOperationsResults', count: number, pages: number, data: Array<{ __typename?: 'BulkOperation', id: string, outfitter_id: string, type: Types.BulkOperationType, status: Types.BulkOperationStatus, total_count: number, processed_count: number, successful_count: number, failed_count: number, created_at: number, started_at?: number | null, updated_at: number, completed_at?: number | null, attributes?: { __typename?: 'BulkOperationAttributes', template_id?: string | null, topic_entity_id?: string | null } | null, errors?: Array<{ __typename?: 'BulkOperationError', id: string, row_index: number, data: any, error: string, completed_at?: number | null }> | null }> } };

export const BulkOperationErrorFieldsFragmentDoc = gql`
    fragment BulkOperationErrorFields on BulkOperationError {
  id
  row_index
  data
  error
  completed_at
}
    `;
export const BulkOperationFieldsFragmentDoc = gql`
    fragment BulkOperationFields on BulkOperation {
  id
  outfitter_id
  type
  status
  total_count
  processed_count
  successful_count
  failed_count
  created_at
  started_at
  updated_at
  completed_at
  attributes {
    template_id
    topic_entity_id
  }
  errors {
    ...BulkOperationErrorFields
  }
}
    ${BulkOperationErrorFieldsFragmentDoc}`;
export const BulkOperationDocument = gql`
    query bulkOperation($id: ID!) {
  bulkOperation(id: $id) {
    ...BulkOperationFields
  }
}
    ${BulkOperationFieldsFragmentDoc}`;

/**
 * __useBulkOperationQuery__
 *
 * To run a query within a React component, call `useBulkOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBulkOperationQuery(baseOptions: Apollo.QueryHookOptions<BulkOperationQuery, BulkOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkOperationQuery, BulkOperationQueryVariables>(BulkOperationDocument, options);
      }
export function useBulkOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkOperationQuery, BulkOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkOperationQuery, BulkOperationQueryVariables>(BulkOperationDocument, options);
        }
export type BulkOperationQueryHookResult = ReturnType<typeof useBulkOperationQuery>;
export type BulkOperationLazyQueryHookResult = ReturnType<typeof useBulkOperationLazyQuery>;
export type BulkOperationQueryResult = Apollo.QueryResult<BulkOperationQuery, BulkOperationQueryVariables>;
export const BulkOperationsDocument = gql`
    query bulkOperations($outfitterId: ID!, $types: [BulkOperationType!], $attributes: BulkOperationAttributesFilter, $paging: Paging) {
  bulkOperations(
    outfitterId: $outfitterId
    types: $types
    attributes: $attributes
    paging: $paging
  ) {
    count
    pages
    data {
      ...BulkOperationFields
    }
  }
}
    ${BulkOperationFieldsFragmentDoc}`;

/**
 * __useBulkOperationsQuery__
 *
 * To run a query within a React component, call `useBulkOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkOperationsQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      types: // value for 'types'
 *      attributes: // value for 'attributes'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useBulkOperationsQuery(baseOptions: Apollo.QueryHookOptions<BulkOperationsQuery, BulkOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkOperationsQuery, BulkOperationsQueryVariables>(BulkOperationsDocument, options);
      }
export function useBulkOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkOperationsQuery, BulkOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkOperationsQuery, BulkOperationsQueryVariables>(BulkOperationsDocument, options);
        }
export type BulkOperationsQueryHookResult = ReturnType<typeof useBulkOperationsQuery>;
export type BulkOperationsLazyQueryHookResult = ReturnType<typeof useBulkOperationsLazyQuery>;
export type BulkOperationsQueryResult = Apollo.QueryResult<BulkOperationsQuery, BulkOperationsQueryVariables>;